import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { ForecastDto } from 'types';

export const getForecast = async (
  locationId: number | undefined | null
): Promise<ForecastDto | undefined> => {
  if (locationId === undefined || locationId === null || locationId < 1) return;
  const { data } = await axios.get(`/api/weather/${locationId}`);
  return data as ForecastDto;
};

type QueryFnType = typeof getForecast;

type UseForecastOptions = {
  locationId: number | undefined | null;
  config?: QueryConfig<QueryFnType>;
};

export const useForecast = ({ locationId, config }: UseForecastOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['forecasts', locationId],
    queryFn: () => getForecast(locationId),
  });
};
